"use strict";

define('rs/form/formobjects/base.formobject',['require','exports','module','underscore','rs/form/abstract.form.entity','rs/form/formobjects/base.formobject.view','rs/form/formobjects/comments.controller','backbone.radio','langs'],function (require, exports, module) {
  var _ = require('underscore');
  var AbstractFormEntity = require('rs/form/abstract.form.entity');
  var BaseFormObjectView = require('rs/form/formobjects/base.formobject.view');
  var CommentsController = require('rs/form/formobjects/comments.controller');
  var Radio = require('backbone.radio');
  var langs = require('langs');
  var FORM_OBJECT_CHANNEL = Radio.channel('formobject');
  var BaseFormObject = AbstractFormEntity.extend({
    properties: ['commentCount', 'indent', 'rowIndex', 'unreadCommentCount'],
    indent: false,
    displayed: true,
    required: false,
    defaultValue: null,
    helpText: '',
    initialize: function initialize(formObject, parent) {
      this.setDepthIndex(parent.getDepthIndex() + 1);
      this._super.apply(this, arguments);
      this.value = this.defaultValue;
      if (!this.isDesignerMode()) {
        this.loadData();
        this.importAnswers();
      }
      var formController = this.getFormController(),
        id = this.getId();
      this.setCommentCount(formController.getFormObjectCommentCountByID(id));
      this.setUnreadCommentCount(formController.getFormObjectCommentUnreadCountByID(id));
      if (!this.isRequiredGroup()) {
        this.refreshValidity();
      }
      this.startListeners();
    },
    startListeners: function startListeners() {
      this._super();
      if (this.isDesignerMode()) {
        this.listenTo(this, 'change:required', this.updateRequiredFieldInidicators);
      } else {
        this.sync('value');
      }
      this.sync('depthIndex');
    },
    updateRequiredFieldInidicators: function updateRequiredFieldInidicators() {
      var formObjectView = this.getView();
      if (formObjectView.isRendered()) {
        var container = formObjectView.createChildElementBeforeEmpty();
        formObjectView.$el.prev('.form-object-spacer').remove();
        formObjectView.render();
        formObjectView.getChildContainer().append(container);
        formObjectView.refresh();
      }
    },
    isRequiredGroup: function isRequiredGroup() {
      return this.getType() == "question" && this.getRequired();
    },
    isCheckboxGroup: function isCheckboxGroup() {
      var children = this.getChildren(),
        child = null,
        len = children ? children.length : 0;
      type = len ? children[0].type : '', i = 0;
      if (type !== 'checkbox') {
        return false;
      }
      for (i = 0; i < len; ++i) {
        child = children[i];
        if (child.type !== type) {
          return false;
        }
      }
      return len > 0 ? true : false;
    },
    isRadioGroup: function isRadioGroup() {
      var children = this.getChildren(),
        child = null,
        len = children ? children.length : 0;
      type = len ? children[0].type : '', i = 0;
      if (type !== 'radio') {
        return false;
      }
      for (i = 0; i < len; ++i) {
        child = children[i];
        if (child.type !== type) {
          return false;
        }
      }
      return len > 0 ? true : false;
    },
    shouldPutCommentContainerAfter: function shouldPutCommentContainerAfter() {
      var children = this.getChildren(),
        child = null,
        len = children ? children.length : 0;
      type = '', i = 0;
      for (i = 0; i < len; ++i) {
        child = children[i];
        if (child.type == 'label') {
          continue;
        }
        type = type || child.type;
        if (child.type !== type) {
          return false;
        }
        if (type != 'radio' && type != 'checkbox') {
          return false;
        }
      }
      return len > 0 ? true : false;
    },
    importAnswers: function importAnswers() {},
    loadData: function loadData() {
      if (this.isDesignerMode()) {
        return;
      }
      if (this.getType() != "question") {}
      var data = this.getFormController().getFormObjectDataByID(this.getId());
      this.setValue(data, {
        silent: true
      });
    },
    viewIsReady: function viewIsReady() {
      var i = 0,
        view = this.getView(),
        children = this.getChildren(),
        rowIndex = this.getRowIndex(),
        len = children.length;
      if (rowIndex == 0) {
        view.setRowFirst();
      }
      FORM_OBJECT_CHANNEL.trigger('before:formobject:render', view);
      view.render();
      FORM_OBJECT_CHANNEL.trigger('formobject:render', view);
      if (this.isDesignerMode()) {
        this.trigger('change:required');
      }
      this.setupChildrenViewProperties();
      this.getView().setRendered();
    },
    refreshDepthIndexPropertyOnView: function refreshDepthIndexPropertyOnView(index) {
      this.getView().setDepthIndex(index);
      if (this.isDesignerMode()) {
        this.getView().refreshColor();
      }
    },
    refreshValuePropertyOnView: function refreshValuePropertyOnView(value) {},
    getFormController: function getFormController() {
      return this.getParent().getFormController();
    },
    isVisible: function isVisible() {
      return this.getDisplayed() && this.getParent().isVisible();
    },
    isValid: function isValid() {
      return !!this.getValid();
    },
    isRequired: function isRequired() {
      return !!this.getRequired();
    },
    isCommentable: function isCommentable() {
      return true;
    },
    refreshValidity: function refreshValidity() {
      this.setValid(this.checkValue());
    },
    valueDidChange: function valueDidChange() {
      if (!this.isRequiredGroup()) {
        this.refreshValidity();
      }
      this.getSectionController().formObjectValueDidChange();
      this.getFormController().formObjectValueDidChange();
    },
    getTemplateProperties: function getTemplateProperties() {
      var properties = {
        id: this.getId(),
        elementId: this.getElementId(),
        required: this.getRequired(),
        group: this.isGroup(),
        value: this.getValue(),
        text: this.getText(),
        label: this.getLabel(),
        description: this.getDescription(),
        margin: false,
        extra: false,
        designer: this.isDesignerMode(),
        canEdit: this.getFormController().canEditDocument(),
        disabled: false,
        diffViewer: this.isDiffViewer(),
        helpText: this.getHelpText(),
        compoundType: this.getCompoundType(),
        readOnly: this.isReadOnly(),
        ariaLabel: this.getLabel() ? langs.phrase('Submissions.Edit.HelpText.ARIALabel.Prefix') + this.getLabel() : langs.phrase('Submissions.Edit.HelpText.ARIALabel.Generic')
      };
      properties.disabled = properties.designer || !properties.canEdit;
      _.extend(properties, this.getCommentProperties());
      properties.extra = this.getView().getExtraContent(properties);
      properties.margin = !(properties.group || properties.extra);
      return properties;
    },
    requestAddCompoundChildren: function requestAddCompoundChildren() {
      var ctype = this.getCompoundType();
      this.requestTypeInsertAtEnd(ctype);
    },
    getCommentProperties: function getCommentProperties() {
      var commentCount = this.getCommentCount() || 0,
        permissions = this.getFormController().getPermissions(),
        canReadComments = permissions.canReadComments,
        designerMode = this.isDesignerMode(),
        commentable = this.isCommentable();
      var properties = {
        showCommentCount: canReadComments && commentCount && !designerMode && commentable,
        showCommentAdd: canReadComments && this.getFormController().canAddComments() && !commentCount && !designerMode && commentable,
        unreadCount: this.getUnreadCommentCount(),
        open: this.commentsController ? this.commentsController.getVisible() : false,
        commentCount: commentCount,
        comments: false
      };
      properties.comments = properties.showCommentCount || properties.showCommentAdd;
      return properties;
    },
    getLabeledText: function getLabeledText() {
      var label = this.getLabel(),
        text = this.getText();
      return (label ? label + '. ' : '') + (text || '');
    },
    getCommentsControllerInstance: function getCommentsControllerInstance() {
      var ctrl = this.commentsController;
      if (ctrl == null) {
        this.getView().createCommentsContainer();
        ctrl = new CommentsController({
          formObject: this,
          documentModel: this.getFormController().getDocumentModel(),
          permissions: this.getFormController().getPermissions(),
          formController: this.getFormController()
        });
        ctrl.setup(this.getView().getCommentsContainer());
        this.commentsController = ctrl;
      }
      return ctrl;
    },
    displayCommentContainer: function displayCommentContainer() {
      var ctr = this.getCommentsControllerInstance();
      if (!ctr.visible) {
        return this.getView().showCommentContainer();
      }
      return Promise.resolve();
    },
    displayedDidChange: function displayedDidChange() {
      var i = 0,
        children = this.getChildren(),
        len = children.length;
      for (i = 0; i < len; ++i) {
        children[i].parentDisplayDidChange();
      }
    },
    canAddChildFormObject: function canAddChildFormObject(potentialChild) {
      if (!this._super.apply(this, arguments)) {
        return false;
      }
      if (potentialChild) {
        var compoundType = this.getCompoundType();
        if (compoundType && compoundType != potentialChild.getType()) {
          return false;
        } else if (!compoundType && potentialChild.isCompoundChild()) {
          return false;
        }
      }
      return true;
    },
    refreshDisplayedPropertyOnView: function refreshDisplayedPropertyOnView(displayed) {
      if (displayed) {
        this.getView().show();
      } else {
        this.getView().hide();
      }
    },
    isReadOnly: function isReadOnly() {
      return this.getFormController().isReadOnly();
    },
    parentDisplayDidChange: function parentDisplayDidChange() {
      var i = 0,
        children = this.getChildren(),
        len = children.length;
      for (i = 0; i < len; ++i) {
        children[i].parentDisplayDidChange();
      }
    },
    requestValueChange: function requestValueChange() {
      if (!this.isReadOnly()) {
        var value = this.getView().getValue();
        this.setValue(value);
      }
    },
    checkValue: function checkValue() {
      return !!this.getValue();
    },
    setupView: function setupView() {
      this.setView(new BaseFormObjectView());
    },
    requestTypeInsertAtIndex: function requestTypeInsertAtIndex(type, index) {
      this.getFormController().newFormObjectByType(type, this, index);
    },
    requestTypeInsertAtEnd: function requestTypeInsertAtEnd(type) {
      this.requestTypeInsertAtIndex(type, this.getChildren().length);
    },
    isDesignerMode: function isDesignerMode() {
      return this.getFormController().isDesignerMode();
    },
    isDiffViewer: function isDiffViewer() {
      return this.getFormController().isDiffViewer();
    },
    updateCommentCount: function updateCommentCount(count, unread) {
      this.setCommentCount(count);
      this.setUnreadCommentCount(unread);
      this.getView().refreshCommentContainer();
    },
    toJSON: function toJSON() {
      var json = this._super.apply(this, arguments);
      json.required = this.getRequired();
      json.helpText = this.getHelpText();
      json.compoundType = this.getCompoundType();
      return json;
    }
  });
  module.exports = BaseFormObject;
});

